var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCroatiaCroatiaLoto7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.431 34.329H79.35c8.43 0 15.219 7.017 15.219 15.639 0 7.965-6.68 15.703-14.682 15.703H5.431V34.329z",
    fill: "#d10000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.265 38.877c6.024 0 10.909 5.012 10.909 11.2s-4.885 11.191-10.909 11.191-10.9-5.012-10.9-11.191 4.885-11.2 10.9-11.2zm-41.949.191c6.024 0 10.9 5.012 10.9 11.2S42.34 61.46 36.316 61.46s-10.909-5.012-10.909-11.191 4.894-11.2 10.909-11.2zm0 5.468c2.962 0 5.368 2.47 5.368 5.514 0 3.053-2.406 5.523-5.368 5.523-2.971 0-5.368-2.47-5.368-5.523 0-3.044 2.397-5.514 5.368-5.514zm12.513-4.766h17.224v4.857h-5.942v15.484h-5.34V44.628h-5.942zM23.922 60.111v-4.867h-8.038V39.77h-5.35v20.341h13.388z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.61 48.884h7.181l-6.543 12.978 5.659.073 9.15-18.163H70.61z",
    fill: "#d10000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M-96 74.5a.5.5 0 1 1 1 0 .5.5 0 1 1-1 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroatiaCroatiaLoto7);
export default __webpack_public_path__ + "static/media/croatia_croatia_loto_7.a8d05479af37d01f2b966b373524b261.svg";
export { ForwardRef as ReactComponent };